import { render, staticRenderFns } from "./MessageComment.vue?vue&type=template&id=6c1a668e&"
import script from "./MessageComment.vue?vue&type=script&lang=js&"
export * from "./MessageComment.vue?vue&type=script&lang=js&"
import style0 from "./MessageComment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports